import { Entity } from "@rest-hooks/endpoint";
import { ApplicationMortgageERegistration } from "..";

export class ApplicationMortgageERegistrationEntity
	extends Entity
	implements ApplicationMortgageERegistration
{
	constructor() {
		super();
		this.applicationId = 0;
		this.applicationMortgageERegistrationId = 0;
		this.documentYear = 0;
		this.documentNumber = 0;
		this.documentOffice = "";
		this.message = "";
		this.status = "";
		this.registrationDate = "";
		this.registrationTime = "";
		this.mortgageValue = 0;
		this.expirationDate = "";
	}

	readonly applicationId?: number;
	readonly applicationMortgageERegistrationId?: number;
	readonly documentYear?: number;
	readonly documentNumber?: number;
	readonly documentOffice?: string;
	readonly message?: string;
	readonly status?: string;
	readonly registrationDate?: string;
	readonly registrationTime?: string;
	readonly mortgageValue?: number;
	readonly expirationDate?: string;

	pk(parent?: any, key?: string) {
		return this.applicationMortgageERegistrationId?.toString() ?? "";
	}
}
